"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-empty */
var reducers_1 = require("../../reducers");
var Action_1 = require("../../Services/Redux/Action");
exports.registerGlobalInterceptor = function () {
    window.onerror = function (event, source, lineno, colno, error) {
        var store = reducers_1.getStore();
        store.dispatch(Action_1.notifyErrorAction({
            event: event,
            source: source,
            lineno: lineno,
            colno: colno,
            error: error
        }, false));
    };
    window.onunhandledrejection = function (ev) {
        var store = reducers_1.getStore();
        var lastError = localStorage.getItem('lastApiError');
        if (lastError) {
            try {
                var errorApi = JSON.parse(lastError);
                store.dispatch(Action_1.notifyApiErrorAction(errorApi, true, false));
            }
            catch (_a) { }
        }
        else {
            store.dispatch(Action_1.notifyErrorAction({
                event: ev.reason
            }, false));
        }
    };
};
//# sourceMappingURL=registerGlobalInterceptor.js.map